import {
  LOAD_UNITS_LANGUAGES_PENDING,
  LOAD_UNITS_LANGUAGES_FULFILLED,
  LOAD_UNITS_LANGUAGES_REJECTED,
  LOAD_UNITS_LANGUAGES_LOCALE_PENDING,
  LOAD_UNITS_LANGUAGES_LOCALE_FULFILLED,
  LOAD_UNITS_LANGUAGES_LOCALE_REJECTED,
  LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_PENDING,
  LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_FULFILLED,
  LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_REJECTED,
  LOAD_NEW_UNITS_LANGUAGES_PENDING,
  LOAD_NEW_UNITS_LANGUAGES_FULFILLED,
  LOAD_NEW_UNITS_LANGUAGES_REJECTED,
  POST_UNITS_LANGUAGES_PENDING,
  POST_UNITS_LANGUAGES_FULFILLED,
  POST_UNITS_LANGUAGES_REJECTED,
  PUT_UNITS_LANGUAGES_PENDING,
  PUT_UNITS_LANGUAGES_FULFILLED,
  PUT_UNITS_LANGUAGES_REJECTED,
  DELETE_UNITS_LANGUAGES_PENDING,
  DELETE_UNITS_LANGUAGES_FULFILLED,
  DELETE_UNITS_LANGUAGES_REJECTED,
  DELETE_UNITS_LANGUAGES_TRANSLATION_PENDING,
  DELETE_UNITS_LANGUAGES_TRANSLATION_FULFILLED,
  DELETE_UNITS_LANGUAGES_TRANSLATION_REJECTED,
  DOWNLOAD_UNITS_LANGUAGES_PENDING,
  DOWNLOAD_UNITS_LANGUAGES_FULFILLED,
  DOWNLOAD_UNITS_LANGUAGES_REJECTED,
  CLEAR_UNITS_LANGUAGES_MESSAGES,
} from '../actions/unitsLanguages'
import i18n from 'i18next'

export default function unitsLanguages(state = {}, action) {
  switch (action.type) {
    case LOAD_UNITS_LANGUAGES_PENDING:
    case LOAD_NEW_UNITS_LANGUAGES_PENDING:
    case POST_UNITS_LANGUAGES_PENDING:
    case PUT_UNITS_LANGUAGES_PENDING:
    case DELETE_UNITS_LANGUAGES_PENDING:
    case DELETE_UNITS_LANGUAGES_TRANSLATION_PENDING:
    case LOAD_UNITS_LANGUAGES_LOCALE_PENDING:
    case LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_PENDING:
    case DOWNLOAD_UNITS_LANGUAGES_PENDING:
      return {
        ...state,
        isLoading: true,
        successMessage: null,
        errorMessage: null,
      }
    case LOAD_UNITS_LANGUAGES_REJECTED:
    case LOAD_NEW_UNITS_LANGUAGES_REJECTED:
    case POST_UNITS_LANGUAGES_REJECTED:
    case PUT_UNITS_LANGUAGES_REJECTED:
    case DELETE_UNITS_LANGUAGES_REJECTED:
    case DELETE_UNITS_LANGUAGES_TRANSLATION_REJECTED:
    case LOAD_UNITS_LANGUAGES_LOCALE_REJECTED:
    case LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_REJECTED:
    case DOWNLOAD_UNITS_LANGUAGES_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload?.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_UNITS_LANGUAGES_LOCALE_FULFILLED:
      return {
        ...state,
        unitsLanguagesLocales: action.payload?.data || [],
        isLoading: false,
      }
    case DOWNLOAD_UNITS_LANGUAGES_FULFILLED:
      return {
        ...state,
        unitsLanguagesCSV: action.payload?.data || [],
        isLoading: false,
      }
    case LOAD_UNITS_LANGUAGES_PRODUCT_TYPES_FULFILLED:
      return {
        ...state,
        unitsLanguagesProductTypes: action.payload?.data || [],
        isLoading: false,
      }
    case LOAD_UNITS_LANGUAGES_FULFILLED: {
      const existing = state?.unitsLanguages || []
      const incoming = action.payload?.data || []
      const incomingIds = new Set(incoming.map((it) => it.id))
      const merged = existing.filter((x) => !incomingIds.has(x.id)).concat(incoming)
      return {
        ...state,
        unitsLanguages: merged,
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    }
    case LOAD_NEW_UNITS_LANGUAGES_FULFILLED:
      return {
        ...state,
        unitsLanguages: action.payload?.data || [],
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    case POST_UNITS_LANGUAGES_FULFILLED: {
      const created = action.payload
      const list = state?.unitsLanguages || []
      return {
        ...state,
        unitsLanguages: [created, ...list],
        isLoading: false,
        successMessage: i18n.t('units_languages_context.created_successfully'),
      }
    }
    case PUT_UNITS_LANGUAGES_FULFILLED: {
      const updated = action.payload
      const list = state?.unitsLanguages || []
      const nextList = list.map((it) => (it.id === updated.id ? updated : it))
      const nextDetails = state.langDetails && state.langDetails.id === updated.id ? { ...updated } : state.langDetails
      return {
        ...state,
        unitsLanguages: nextList,
        langDetails: nextDetails,
        isLoading: false,
        successMessage: i18n.t('units_languages_context.updated_successfully'),
      }
    }
    case DELETE_UNITS_LANGUAGES_TRANSLATION_FULFILLED: {
      const tid = String(action.meta?.translationId ?? action.meta?.id ?? action.payload?.id)
      const updatedUnitsLanguagesList = (state.unitsLanguages || []).map((item) => {
        const arr = item.unitLanguages || []
        if (!arr.length) return item
        const has = arr.some((tr) => String(tr.id) === tid)
        if (!has) return item
        const nextTranslations = arr.filter((tr) => String(tr.id) !== tid)
        return { ...item, unitLanguages: nextTranslations }
      })
      const updatedLangDetails = state.langDetails?.unitLanguages
        ? {
            ...state.langDetails,
            unitLanguages: state.langDetails.unitLanguages.filter((tr) => String(tr.id) !== tid),
          }
        : state.langDetails
      return {
        ...state,
        unitsLanguages: updatedUnitsLanguagesList,
        langDetails: updatedLangDetails,
        isLoading: false,
        successMessage: i18n.t('units_languages_context.translation_deleted_successfully'),
      }
    }
    case DELETE_UNITS_LANGUAGES_FULFILLED: {
      const id = action.meta?.id
      const next = (state?.unitsLanguages || []).filter((item) => item.id !== id)
      const nextDetails = state.langDetails && state.langDetails.id === id ? null : state.langDetails
      return {
        ...state,
        unitsLanguages: next,
        langDetails: nextDetails,
        isLoading: false,
        successMessage: i18n.t('units_languages_context.language_deleted_successfully'),
      }
    }
    case CLEAR_UNITS_LANGUAGES_MESSAGES:
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      }
    default:
      return state
  }
}
